let hasFailed = false;

const optImportLocale = (lang: string) => {
  try {
    const dir = 'locales';
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const res = require(`../${dir}/${lang}/translation.json`);
    return res;
  } catch (e) {
    hasFailed = true;
    return {};
  }
};

const de = optImportLocale('de');
const en = optImportLocale('en');
const es = optImportLocale('es');
const fi = optImportLocale('fi');
const fr = optImportLocale('fr');
const it = optImportLocale('it');
const nl = optImportLocale('nl');
const cs = optImportLocale('cs');
const et = optImportLocale('et');

// Speur- en Specialistische Dieren (dutch)
// A custom language and workaround for dogs instead of horses.
// It's basically a find/replace of paard->hond in dutch.
// Is this a workaround? Yes!
const ssd = optImportLocale('ssd');

export { de, en, es, fi, fr, it, nl, cs, et, ssd, hasFailed };
